import React from "react";

export function PriceIndicator({level}: {level: number}) {

  const min = "M 3 5 L 10 5 L 6.5 11 L 3 5 Z"
  const mid = "M 12 5 L 19 5 L 15.5 11 L 12 5 Z"
  const max = "M 22 5 L 29 5 L 25.5 11 L 22 5 Z"

  let ptr = min;
  if(level == 1) ptr = mid;
  else if(level == 2) ptr = max;

  return <>

    <svg width="32" height="32" viewBox="0 0 32 32">
      <path fill="none" d="M0 0h32v32H0z"/>
      <path d="M9 19H5a3 3 0 0 1-3-3 3 3 0 0 1 3-3h4z" fill="#34a853"/>
      <path d="M27 19h-4v-6h4a3 3 0 0 1 3 3 3 3 0 0 1-3 3z" fill="#ea4335"/>
      <path fill="#fcc934" d="M10 13h12v6H10z"/>
      <path fill="#1967d2" fill-rule="evenodd" d={ptr}/>
    </svg>

  </>
}